import Color from 'color';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import styled, { keyframes } from 'styled-components';

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 36px);
  max-height: calc(100% - 36px);
  min-height: 0;
  padding: 8px 24px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  font-family: inherit;
  animation: ${fadeUp} 220ms ease;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0;
`;

export const HeaderIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Color(lFColor0).darken(0.05).toString()};
  background: #f1f3f5;
  border: 1px solid #e9ecef;
  svg {
    font-size: 22px !important;
  }
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
  padding-top: 2px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #212529;
  letter-spacing: -0.02em;
  line-height: 1.2;
`;

export const Sub = styled.div`
  font-size: 13px;
  color: #6c757d;
  line-height: 1.45;
`;

export const Frame = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  overflow: hidden;
`;

export const Img = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
`;

export const Loading = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Hint = styled.div`
  font-size: 13px;
  color: #6c757d;
  padding: 24px;
  text-align: center;
`;
